import { PieChart, Pie } from "recharts";

import { getChartColor } from "../helpers/functions";

export default function StandardPieChart({ chart, children }) {
  const dimensions = chart?.dimensions || [];
  const measures = chart?.measures || [];
  const data = chart?.data || [];
  const pie_chart_data_pairs = dimensions.flatMap((dimension) =>
    measures.map((measure) => [dimension.data_key, measure.data_key])
  );
  const pie_chart_data = pie_chart_data_pairs.map((combo) =>
    data.map((row, idx) => ({
      name: row[combo[0]],
      value: row[combo[1]],
      fill: getChartColor(idx),
    }))
  );
  return (
    <PieChart width="100%">
      {pie_chart_data.map((pieData, idx) => (
        <Pie
          key={idx}
          data={pieData}
          dataKey="value"
          nameKey="name"
          outerRadius="80%"
          innerRadius="60%"
        />
      ))}
      {children}
    </PieChart>
  );
}
